import { createContext, useContext, useState, useEffect } from 'react';

// الألوان المتاحة
export const THEME_COLORS = {
  emerald: {
    name: 'أخضر زمردي',
    primary: 'emerald',
    gradient: 'from-emerald-500 to-emerald-600',
    bg: 'bg-emerald-500',
    bgHover: 'hover:bg-emerald-600',
    text: 'text-emerald-500',
    border: 'border-emerald-500',
    ring: 'ring-emerald-500',
    hex: '#10b981'
  },
  blue: {
    name: 'أزرق',
    primary: 'blue',
    gradient: 'from-blue-500 to-blue-600',
    bg: 'bg-blue-500',
    bgHover: 'hover:bg-blue-600',
    text: 'text-blue-500',
    border: 'border-blue-500',
    ring: 'ring-blue-500',
    hex: '#3b82f6'
  },
  purple: {
    name: 'بنفسجي',
    primary: 'purple',
    gradient: 'from-purple-500 to-purple-600',
    bg: 'bg-purple-500',
    bgHover: 'hover:bg-purple-600',
    text: 'text-purple-500',
    border: 'border-purple-500',
    ring: 'ring-purple-500',
    hex: '#a855f7'
  },
  rose: {
    name: 'وردي',
    primary: 'rose',
    gradient: 'from-rose-500 to-rose-600',
    bg: 'bg-rose-500',
    bgHover: 'hover:bg-rose-600',
    text: 'text-rose-500',
    border: 'border-rose-500',
    ring: 'ring-rose-500',
    hex: '#f43f5e'
  },
  orange: {
    name: 'برتقالي',
    primary: 'orange',
    gradient: 'from-orange-500 to-orange-600',
    bg: 'bg-orange-500',
    bgHover: 'hover:bg-orange-600',
    text: 'text-orange-500',
    border: 'border-orange-500',
    ring: 'ring-orange-500',
    hex: '#f97316'
  },
  amber: {
    name: 'ذهبي',
    primary: 'amber',
    gradient: 'from-amber-500 to-amber-600',
    bg: 'bg-amber-500',
    bgHover: 'hover:bg-amber-600',
    text: 'text-amber-500',
    border: 'border-amber-500',
    ring: 'ring-amber-500',
    hex: '#f59e0b'
  },
  cyan: {
    name: 'سماوي',
    primary: 'cyan',
    gradient: 'from-cyan-500 to-cyan-600',
    bg: 'bg-cyan-500',
    bgHover: 'hover:bg-cyan-600',
    text: 'text-cyan-500',
    border: 'border-cyan-500',
    ring: 'ring-cyan-500',
    hex: '#06b6d4'
  },
  indigo: {
    name: 'نيلي',
    primary: 'indigo',
    gradient: 'from-indigo-500 to-indigo-600',
    bg: 'bg-indigo-500',
    bgHover: 'hover:bg-indigo-600',
    text: 'text-indigo-500',
    border: 'border-indigo-500',
    ring: 'ring-indigo-500',
    hex: '#6366f1'
  },
  pink: {
    name: 'زهري',
    primary: 'pink',
    gradient: 'from-pink-500 to-pink-600',
    bg: 'bg-pink-500',
    bgHover: 'hover:bg-pink-600',
    text: 'text-pink-500',
    border: 'border-pink-500',
    ring: 'ring-pink-500',
    hex: '#ec4899'
  },
  red: {
    name: 'أحمر',
    primary: 'red',
    gradient: 'from-red-500 to-red-600',
    bg: 'bg-red-500',
    bgHover: 'hover:bg-red-600',
    text: 'text-red-500',
    border: 'border-red-500',
    ring: 'ring-red-500',
    hex: '#ef4444'
  }
};

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [themeColor, setThemeColor] = useState('emerald');
  
  useEffect(() => {
    // تحميل اللون المحفوظ
    const savedColor = localStorage.getItem('themeColor');
    if (savedColor && THEME_COLORS[savedColor]) {
      setThemeColor(savedColor);
    }
  }, []);
  
  const changeThemeColor = (colorKey) => {
    if (THEME_COLORS[colorKey]) {
      setThemeColor(colorKey);
      localStorage.setItem('themeColor', colorKey);
    }
  };
  
  const theme = THEME_COLORS[themeColor] || THEME_COLORS.emerald;
  
  return (
    <ThemeContext.Provider value={{ 
      themeColor, 
      theme, 
      changeThemeColor,
      colors: THEME_COLORS 
    }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
